import _util from '../../utils/';


const commonService = {
	loadAllWeeks(gets, resolve, reject) {
		_util.request({
			url: '/api/Common/GetWeeksList',
			data: gets,
			success: resolve,
			error: reject
		})
	},
	sendSms (payload, resolve, reject) {
		_util.request({
			url: '/api/auth/send_code_by_phone',
			method: "post",
			data: payload,
			success: resolve,
			error: reject
		})
	},
	verifySmsCode (payload, resolve, reject) {
		_util.request({
			url: '/api/auth/verifyCode',
			method: "post",
			data: payload,
			success: resolve,
			error: reject
		})
	},
	checkSecondPassword (payload, resolve, reject) {
		_util.request({
			url: '/api/auth/check_second_password',
			method: "post",
			data: payload,
			success: resolve,
			error: reject
		})
	},
}

export default commonService;


// WEBPACK FOOTER //
// ./src/services/Common/common-service.js